(function() {
  angular.module('forgotUser')
  .controller('forgotUserConfirmation', ['$scope', '$q','$log','$state', '$timeout', '$translate',
    function($scope, $q, $log, $state, $timeout, $translate) {
      var vm = this;
      vm.stateParams = $state.params;
      vm.returnHome = returnHome;
      displayText(vm.stateParams);

      function displayText(stateParams) {
          $scope.text = "Your User ID is:";
          $scope.userId = stateParams.response.users[0].userId;
      }

      function returnHome() {
        $state.go('root');
      }
    }]);
})();
